import React, {
    useContext,
    useEffect,
    useState,
} from 'react';
import { useSelector } from 'react-redux';
import { GameItem } from '../GameItem/GameItem';
import { SearchSectionTitle } from '../SearchSectionTitle/SearchSectionTitle';
import { useRecommendedGamesHook } from '../../../shared/src/hooks/use-recommended-games.hook';
import { AsgFwContext, AsgDictionaryContext } from '../../contexts';
import { useNeoCmsFeatureRelatedGamesHook } from '../../../shared/src/hooks/use-neo-cms-feature-related-games.hook';
import { NeoCmsGameCategoryFeatureNamesEnum } from '../../../shared/src/enums/neo-cms-game-category-feature-names.enum';

export const RecommendedGames = ({
    handleSearchOpenStatus,
    setHasGames = null,
}) => {
    const dictionary = useContext(AsgDictionaryContext);
    const AsgFW = useContext(AsgFwContext);
    const { isNeoCmsIntegrationEnabled } = useSelector(state => state.app);
    const featureName = NeoCmsGameCategoryFeatureNamesEnum.SEARCH_TRENDING;
    const { featureRelatedGames } = useNeoCmsFeatureRelatedGamesHook(featureName);
    const { recommendedGames } = useRecommendedGamesHook({ AsgFW });
    const [gamesToShow, setGamesToShow] = useState([]);
    const trendingTitle = dictionary.translate('trending');

    useEffect(() => {
        setGamesToShow(isNeoCmsIntegrationEnabled
            ? featureRelatedGames.slice(0, 20)
            : recommendedGames);
    }, [featureRelatedGames, recommendedGames, isNeoCmsIntegrationEnabled]);

    // Inform parent about changes.
    useEffect(() => {
        if (setHasGames) {
            setHasGames(gamesToShow.length > 0);
        }
    }, [gamesToShow]);

    if (!gamesToShow.length) {
        return null;
    }

    return (
        <>
            <SearchSectionTitle title={trendingTitle} />
            {gamesToShow.map((item) => (
                <GameItem onOpenGame={() => {
                    handleSearchOpenStatus(item);
                }}
                key={item.id}
                data={item}
                />
            ))
            }
        </>
    );
};
